import { render, staticRenderFns } from "./installments.vue?vue&type=template&id=794a05ca&"
import script from "./installments.vue?vue&type=script&lang=js&"
export * from "./installments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports